<script lang="ts">
  let { title = 'Guía rápida', children }: { title?: string; children?: import('svelte').Snippet } = $props();
  let abierto = $state(false);
</script>

<div class="help">
  <button type="button" class="help-btn" onclick={() => abierto = !abierto} aria-expanded={abierto}>
    ? {title}
  </button>
  {#if abierto}
    <div class="help-body">
      {@render children?.()}
    </div>
  {/if}
</div>

<style>
  .help { margin: 0 0 0.75rem; }
  .help-btn {
    border: 1px solid #bbf7d0; background: #f0fdf4; color: #166534;
    font: inherit; font-size: 0.8rem; font-weight: 700;
    padding: 0.35rem 0.7rem; border-radius: 999px; cursor: pointer;
  }
  .help-btn:hover { background: #dcfce7; }
  .help-body {
    margin-top: 0.45rem; padding: 0.75rem 0.9rem;
    background: #fff; border: 1px solid #e5e7eb; border-radius: 10px;
    font-size: 0.85rem; color: #374151; line-height: 1.45;
  }
  .help-body :global(ol), .help-body :global(ul) { margin: 0.3rem 0 0; padding-left: 1.2rem; }
  .help-body :global(li) { margin: 0.2rem 0; }
</style>
